
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import news1 from "../../static/news/ysh1.jpg"
import news2 from "../../static/news/ysh2.jpg"
import news3 from "../../static/news/ysh3.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'4'} />
        <AboutTitle name={'新闻动态'} english={'NEWS'}  />
        <div className='newsCon'>
          <h3 className='title'>著名书法家燕霜红先生为公司成立8周年题词</h3>
          <div className='time'>发布时间：2025-12-09</div>
          <div className='newsCon-con'>
            <p>近日，国内著名书法家、诗人燕霜红先生为深圳市远东数智采技术服务有限公司 8 周年挥毫题词，以翰墨雅韵给公司的发展送上了满满的祝福。</p>
            <p>燕霜红先生深耕书法领域数十载，自幼醉心笔墨，一生寄情山水，其书法功力深厚、风格独特，兼具传统底蕴与个人创新，且为人谦逊低调、淡泊名利，在书画界享有颇高声誉，曾为 “香远塔” 等诸多地标、作品题字，还著有《枫叶荻花集》等书法著作。此次为企业八周年题词，其笔墨间既饱含对企业八载耕耘成果的肯定，又蕴藏着对企业未来行稳致远、再创佳绩的美好期许，为企业周年庆典增添了浓厚的文化底蕴与艺术氛围。</p>
            <p><img src={news2} /></p>
            <p><img src={news1} /></p>
            <p><img src={news3} /></p>
          </div>
        </div>
      </PageBox>
    </>
  );
}
